document.addEventListener('DOMContentLoaded', () => {
    const mainCollection = document.querySelector('.js-main-collection');
    const sidebarCollection = document.querySelector('#sidebar');
    const headerNavigation = document.querySelector('.header-navigation');
    if(!sidebarCollection || !mainCollection) return;

    let sidebarWidth;
    let left;
    let top;

    const calculateSize = () => {
        sidebarCollection.classList.remove('active-sticky-sidebar');
        sidebarCollection.style.width = '';
        sidebarCollection.style.left = '';
        sidebarCollection.style.top = '';

        sidebarWidth = sidebarCollection.offsetWidth;
        left = sidebarCollection.getBoundingClientRect().left;

        if(headerNavigation) {
            top = headerNavigation.offsetHeight;
        }else {
            top = 0;
        }

        const availableHeight = window.innerHeight - top;

        if(sidebarCollection.offsetHeight > window.innerHeight) {
            sidebarCollection.style.overflowY = 'auto';
            // sidebarCollection.style.height = `${window.innerHeight}px`;
            sidebarCollection.style.height = `${availableHeight}px`;
        }else {
            sidebarCollection.style.overflowY = '';
            sidebarCollection.style.height = '';
        }
    }

    const handleScroll = () => {
        const rect = mainCollection.getBoundingClientRect();
        const scrollY = window.scrollY;
        const collectionTop = rect.top + scrollY;
        const collectionBottom = rect.bottom + scrollY;
        
        const startSticky = scrollY >= collectionTop && scrollY <= collectionBottom;
        const stopSticky = rect.bottom >= window.innerHeight;

        if( startSticky && stopSticky) {
            sidebarCollection.classList.add('active-sticky-sidebar');
            sidebarCollection.style.width = `${sidebarWidth}px`;
            sidebarCollection.style.left = `${left}px`;
            sidebarCollection.style.top = `${top}px`;
        } else {
            sidebarCollection.classList.remove('active-sticky-sidebar');
            sidebarCollection.style.width = '';
            sidebarCollection.style.left = '';
            sidebarCollection.style.top = '';
        }
    }

    window.addEventListener('load', () => {
        calculateSize();
        handleScroll();
    });

    window.addEventListener('scroll', handleScroll);

    window.addEventListener('resize', () => {
        calculateSize();
        handleScroll();
    });
});